"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchActiveQuotes = void 0;

var _immutable = require("immutable");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

/*
 * NOTE: This endpoint will hit Salesforce under the covers via a call to:
 * `quoteClient.getPendingApolloQuotesByHubId(hubId)`, only when there are valid
 * pending quotes for this hub. This endpoint should be hit sparingly as
 * our Salesforce API integration has rate limiting.
 *
 * Context: https://git.hubteam.com/HubSpotProtected/UpgradeCatalog/issues/230#issuecomment-464922
 *
 */
var fetchActiveQuotes = function fetchActiveQuotes() {
  var url = 'upgrade-catalog/v1/quotes/active';
  return _apiClient.default.get(url).then(_immutable.fromJS);
};

exports.fetchActiveQuotes = fetchActiveQuotes;


//////////////////
// WEBPACK FOOTER
// ./js/api/QuoteApi.js
// module id = 791
// module chunks = 5 6